export const savjetovanje_r_vijece= {
    templateId: 76,
    category: 7,
    templateTitle: 'Savjetovanje s radničkim vijećem/sindikalnim povjerenikom prije donošenja odluke',
    templateDescription: `<p>Prije donošenja odluke važne za položaj radnika određene Zakonom o radu, poslodavac se mora savjetovati s radničkim vijećem/sindikalnim povjerenikom o namjeravanoj odluci te mora radničkom vijeću dostaviti podatke važne za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, u protivnom je odluka ništetna - ne proizvodi pravne učinke.</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p><strong>Za početak je važno reći da ukoliko kod poslodavca nije utemeljeno radničko vijeće, no postoji imenovan sindikalni povjerenik, da isti preuzima sva prava i obveze radničkog vijeća propisane Zakonom o radu.</strong> </p>
    <p>U tom smislu, sve što se navodi u nastavku u odnosu na radničko vijeće, u cijelosti se primjenjuje i na sindikalnog povjernika koji je imenovan kod poslodavca.</p>
    <p>Prije donošenja odluke važne za položaj radnika, poslodavac se mora savjetovati s radničkim vijećem o namjeravanoj odluci te mora radničkom vijeću dostaviti podatke važne za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika.</p>
    <p>Poslodavac je radničkom vijeću na njegov zahtjev, prije konačnog očitovanja o namjeravanoj odluci poslodavca, dužan omogućiti održavanje sastanka radi dodatnih odgovora i obrazloženja na njihovo izneseno mišljenje.</p>
    <p><strong>Odluka poslodavca donesena protivno odredbama Zakona o radu o obvezi savjetovanja s radničkim vijećem ništetna je.</strong></p>
    <p>Važnim odlukama o kojima se poslodavac mora savjetovati s radničkim vijećem su osobito odluke o (prema Zakonu o radu):</p>
    <p> 1) donošenju pravilnika o radu,</p>
    <p> 2) planu te razvoju i politici zapošljavanja i otkazu,</p>
    <p> 3) kretanju i promjenama u plaćama,</p>
    <p> 4) opsegu i razlozima uvođenja prekovremenog rada, </p>
    <p> 5) broju i vrsti radnika koji su kod njega zaposleni, strukturi zaposlenosti, (broj radnika zaposlenih na određeno vrijeme, na izdvojenom mjestu rada, putem agencije za privremeno zapošljavanje, koji su privremeno ustupljeni u s njim povezano društvo, odnosno koji su kod njega privremeno ustupljeni iz s njim povezanog društva i slično) te razvoju i politici zapošljavanja, </p>
    <p> 6) broju i vrsti radnika kojima je dao pisanu suglasnost za dopunski rad, </p>
    <p> 7) zaštiti zdravlja i sigurnosti na radu i mjerama za poboljšanje uvjeta rada, </p>
    <p> 8) rezultatima provedenih inspekcijskih nadzora u području rada i zaštite na radu, </p>
    <p> 9) drugim pitanjima osobito važnim za gospodarski i socijalni položaj radnika.</p>
    <p>Ako sporazumom poslodavca s radničkim vijećem nije drukčije određeno, radničko vijeće je dužno u roku od osam dana, a u slučaju izvanrednog otkaza u roku od pet dana, dostaviti svoje očitovanje o namjeravanoj odluci poslodavcu.</p>
    <p>Ako se radničko vijeće u navedenom roku ne očituje o namjeravanoj odluci, smatra se da nema primjedbi i prijedloga.</p>
    <p><strong>Važno je naglasiti da poslodavac nije vezan očitovanjem radničkog vijeća/sindikata te svoju odluku može donijeti čak iako se navedeni protive istoj, no dužan je savjetovati se, jer je u protivnom odluka ništetna (ne proizvodi pravne učinke). </strong> </p>
    <br>
        <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Nesavjetovanje s radničkim vijećem / sindikalnim povjerenikom, prije donošenja važne odluke određene Zakonom o radu.</strong></p>
    <p>Pojašnjenje: odluka je ništetna (ne proizvodi pravne učinke), što može biti posebno rizično i štetno za poslodavca ukoliko se išlo u provedbu takve odluke, a osoba na koju se odluka odnosi je pokrenula postupak osporavanja odluke.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu.</p>
  `,
  sides: [
    {
      prefix: "",
      signature: 'Za Poslodavca:',
      inputs: [{
        type: "input",
        required: true,
        placeholder: "R. vijeće / Sindikalni povj.",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ime i prezime",
        help: 'Ime i prezime predsjednika radničkog vijeća ili sindikalnog povjerenika',
      },
    ],
      suffix: "",
    }
  ],

  headline: "",
  
    title: '\r\n\r\nPREDMET: Obavijest Poslodavca prema čl. 150. Zakona o radu',
    noArticleNumbers: true,
    noArticleTitle: true,
    suffix: ' ',

    articles: [
            
                {
                    title: '',
                    mandatory: false,
                    exampleContent: true,
                    dummy: true,
                    statements: [
                        {
                            type: 'text',
                            mandatory: true,
                            editable: true,
                            content: 'PRIMJER KOD DONOŠENJA ODLUKE O RASPOREDU RADNOG VREMENA. \r\nPoštovani,\r\n\r\novim dopisom Vas obavještavamo o namjeri donošenja odluke o rasporedu i planu korištenju godišnjih odmora.\r\nU tom smislu dostavljamo Vam odluku o rasporedu i korištenju godišnjih odmora radi očitovanja, sukladno Zakonu o radu.\r\nUzimajući maksimalno u obzir interese i obveze te prava, kako poslodavca, tako i radnika, molimo da proučite predmetnu Odluku koji vam uz ovu Obavijest dostavljamo te iznesite svoje primjedbe i prijedloge, ukoliko isti postoje.\r\nU slučaju da se ne očitujete u roku 8 dana, po sili Zakona o radu proizlazi da nemate primjedbi i prijedloga na predmetnu odluku, kao i da ste suglasni da u planiranom obliku ista bude provedena.\r\n\r\nS poštovanjem.',
                            help: 'Ova obavijest se odnosi na primjer savjetovanja kod odluke o planu korištenja godišnjih odmora te navedeni prijedlog trebate brisati ili izmijeniti, ovisno o slučaju koji se pojavljuje kod vas.',
                            value: '',
                        }],
                },
                {
                    mandatory: true,
                    static: true,
                    type: 2, // date and place
                    statements: [
                      {
                        type: "input",
                        mandatory: true,
                        parts: [
                          {
                            type: "text",
                            content: "U"
                          },
                          {
                            type: "input",
                            value: "",
                            placeholder: "Upišite mjesto.",
                            required: true,
                          },
                          {
                            type: "text",
                            content: ", dana"
                          },
                          {
                            type: "date",
                            value: new Date(),
                            required: true
                          },
                          {
                            type: "text",
                            content: "godine."
                          }
                        ]
                      },
                    ]
                  },
                  {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
                {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                      {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Dostaviti:\r\n1) Sindikalnom povjerniku / radničkom vijeću Poslodavca \r\n2) Kadrovska služba',
                        help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
                      }
                    ]
                  },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/76_savjetovanje_r_vijece.ts